import React from "react";
import { Offcanvas, OffcanvasBody } from "reactstrap";
import TemplatePreviewSideDrawer from "@workspace/job/src/components/JobOverview/TemplatePreviewSideDrawer/TemplatePreviewSideDrawer";

const OffCanvasWrapper = ({
  isScrollable = false,
  isFilterOpen,
  children,
  width = "75vw",
  closeFilter,
}) => {
  return (
    <Offcanvas
      isOpen={isFilterOpen}
      scrollable={isScrollable}
      toggle={() => closeFilter()}
      direction="end"
      backdrop={true}
      fade={false}
      style={{ width: width }}
    >
      <OffcanvasBody className="p-0 m-0" style={{ height: "40vh" }}>
        {children}
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default OffCanvasWrapper;
